import React from 'react';
import styled from 'styled-components';
import Button from './Button';
import colors from '../styles/colors';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
`;

const Card = styled.div`
  background: ${colors.white};
  border-radius: 8px;
  padding: 24px;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
`;

const Title = styled.h3`
  margin: 0 0 12px 0;
  color: ${colors.lightBlack};
  font-size: 1.8rem;
`;

const Text = styled.p`
  margin: 0 0 20px 0;
  color: ${colors.grey3};
  font-size: 1.4rem;
  line-height: 1.6;
`;

const ButtonRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export default function SmsCampaignOptOutPrompt({
  onStayUnsubscribed,
  onContinue,
  loading,
}) {
  return (
    <Overlay>
      <Card>
        <Title>SMS campaign messages</Title>
        <Text>
          You can remain unsubscribed from promotional SMS campaigns and still use
          Check This Out for referrals and rewards.
        </Text>
        <ButtonRow>
          <Button
            type="button"
            text="UNSUBSCRIBE FROM SMS CAMPAIGNS"
            onClick={onStayUnsubscribed}
            loading={loading}
            width="100%"
          />
          <Button
            type="button"
            text="CONTINUE (RECEIVE SMS CAMPAIGNS)"
            onClick={onContinue}
            disabled={loading}
            width="100%"
            backgroundColor={colors.grey4}
            color={colors.lightBlack}
          />
        </ButtonRow>
      </Card>
    </Overlay>
  );
}
